import type React from 'react';

import { DeletePermissionTagsButton } from '@vlabs/monokit/features/delete-permission-tags';
import { usePermissionTagFromLocation } from '@vlabs/monokit/shared/lib/use-permission-tag-from-location';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { withPermissions, usePageAccess } from '@vlabs/permissions';
import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import { routes } from '../../app/routes';

const DeletePermissionTagButtonWithAccess = withPermissions('permission_tags', 'delete')(DeletePermissionTagsButton);

function PermissionTagPageHeader(): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const pageCtx = usePageContext();
  const permissionTag = usePermissionTagFromLocation();
  const canViewList = usePageAccess('permission_tags');

  return (
    <PageHeader
      actions={[
        <DeletePermissionTagButtonWithAccess
          key="DeletePermissionTagButton"
          onDeletePermissionTags={() => history.push(generatePath(routes.permissionTags.list))}
          permissionTags={[permissionTag]}
          size={pageCtx.buttonSize}
        />,
      ]}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('permission-tag-list-page:title')}
            href={canViewList ? generatePath(routes.permissionTags.list) : undefined}
          />
          <Breadcrumb caption={permissionTag} />
        </Breadcrumbs>
      )}
      title={permissionTag}
    />
  );
}

export { PermissionTagPageHeader };
